module.exports = __webpack_public_path__ + "img/contacts-light.6391c054.svg";